import React from "react";

const DocumentReader = ({ fileBase64, fileType }) => {
  if (!fileBase64) {
    return <div style={{ padding: 20 }}>Nenhum documento para exibir.</div>;
  }

  // Se for imagem
  if (fileType && fileType.startsWith("image/")) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: 20 }}>
        <img src={fileBase64} alt="Documento" style={{ maxWidth: '100%', maxHeight: '100%' }} />
      </div>
    );
  }

  // Se for PDF ou Documento (O iframe por padrão tenta abrir PDFs. Para .docx em base64, alguns navegadores tentarão fazer download).
  // Para suporte completo de .docx sem backend, seria necessária uma biblioteca como react-file-viewer ou mammoth. 
  // No momento, o iframe lida perfeitamente com PDFs e delega o download de doc/docx ao browser se não conseguir renderizar nativamente.
  return (
    <iframe
      src={fileBase64}
      title="Leitor de Documento"
      style={{ width: "100%", height: "100%", border: "none" }}
    />
  );
};

export default DocumentReader;
